import { IControlledMutator, IOptions } from "sonobello.utilities.react";

import { EnhancedCenter } from "../../../Models/Center";
import SessionContextValueProvider from "../../Providers/Value/SessionContextValueProvider";
import UserContextValueProvider from "../../Providers/Value/UserContextValueProvider";
import CenterSelector, { ICenterSelectorProps } from "../Components/CenterSelector";

type SessionContextProvisionedProps = IControlledMutator<EnhancedCenter | null>;

/** A {@link CenterSelector} with some properties provisioned by the Session Context. */
const SessionContextCenterSelector = SessionContextValueProvider<SessionContextProvisionedProps, ICenterSelectorProps>({
  Component: CenterSelector,
  map: ({ customer: { center }, setCustomerInfo }) => ({
    value: center || null,
    onChange: center => setCustomerInfo({ centerId: center ? center.id : null, center: center || undefined })
  })
});

const UserSessionContextCenterSelector = UserContextValueProvider<
  IOptions<EnhancedCenter>,
  Omit<ICenterSelectorProps, keyof SessionContextProvisionedProps>
>({
  Component: SessionContextCenterSelector,
  map: ({ centers }) => ({ options: centers })
});

export const UserContextCenterSelector = UserContextValueProvider<IOptions<EnhancedCenter>, ICenterSelectorProps>({
  Component: CenterSelector,
  map: ({ centers }) => ({ options: centers })
});

export default UserSessionContextCenterSelector;
